/**
 * WELCHES FENSTER GERADE OBEN LIEGT.
 * ============================================================================
 * ESCAPE SCHLIESST EINES UND NICHT ALLE.
 *
 * Jeder Dialog hängt seinen Zuhörer an das FENSTER (`window`), und ein
 * Tastendruck erreicht damit JEDEN, der gerade offen ist. Solange nur einer
 * offen war, ist das nie aufgefallen. Fenster stehen in diesem Haus aber
 * übereinander - die Rückfragen der Terminsteuerung stapeln sich seit dem
 * 03.09.2026, und seit Punkt 21 (08.09.2026) macht man aus der Behördenpost
 * eine Anlage auf, während Betreff und Text darunter schon geschrieben sind.
 * Ein Escape hätte dort die Vorschau UND die Sendung geschlossen.
 *
 * **GENAU DAS SOLL EIN FENSTER STATT EINES NEUEN TABS VERHINDERN.** Punkt 7
 * sagt es wörtlich: „ein neuer Tab ist ein verlassener Vorgang" - und ein
 * Fenster, das den Vorgang darunter mitnimmt, ist nicht besser als der Tab.
 *
 * WARUM DAS OHNE JSX DANEBENSTEHT. Die Regel lautet „liege ich oben", und die
 * kann kein Fenster für sich allein beantworten: sie hängt an allen zusammen.
 * In `Formular.tsx` wäre sie nur mit einer Textsuche zu erreichen, **und eine
 * Textsuche misst, dass etwas dasteht, nicht, dass es stimmt** - achtzehnte
 * Datei dieser Art nach `namen.ts` und den sechzehn danach.
 *
 * DER STAPEL TRÄGT KENNUNGEN UND KEINE FUNKTIONEN. Was hier liegenbliebe,
 * hielte sonst ein ganzes Fenster samt seinen Daten im Speicher fest.
 */

let stapel: number[] = [];
let naechste = 0;

/**
 * Ein Fenster ist aufgegangen und liegt ab jetzt oben.
 *
 * Zurück kommt seine Kennung; sie geht an `abmelden` und an `liegtOben`.
 */
export function anmelden(): number {
  const meine = ++naechste;
  stapel.push(meine);
  return meine;
}

/**
 * Ein Fenster ist zu.
 *
 * ABGERÄUMT WIRD ÜBER DEN WERT UND NICHT ÜBER DIE STELLE. React räumt nicht
 * immer in der Reihenfolge ab, in der gebaut wurde; ein `pop()` nähme dann
 * das falsche, und danach hörte ein Fenster auf Escape, das gar nicht mehr
 * offen ist - oder keines mehr.
 */
export function abmelden(meine: number): void {
  stapel = stapel.filter((x) => x !== meine);
}

/** Liegt dieses Fenster ganz oben? */
export function liegtOben(meine: number): boolean {
  return stapel.length > 0 && stapel[stapel.length - 1] === meine;
}

/**
 * Wie viele Fenster gerade offen sind.
 *
 * NUR FÜR DIE MESSUNG. Kein Bildschirm entscheidet daran etwas: eine Zahl,
 * an der eine Anzeige hängt, wäre eine zweite Wahrheit neben dem Zustand der
 * Fenster selbst.
 */
export function offene(): number {
  return stapel.length;
}
